import axios from 'axios';

const url = process.env.REACT_APP_BASE_API_URL;

export const suspeitaFindByConIdCovIdVeuId = async(susp) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/suspeita/findbyconidcovidveuid/' + susp.con_id + '/' + susp.cov_id + '/' + susp.veu_id, {headers});
}

export const suspeitaInsert = async(susp) => {
  
  const headers = { 'Content-Type': 'application/json'};
  return await axios.post(url + '/v1/suspeita/insert', susp, {headers});
}

export const suspeitaUpdate = async(susp) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.put(url + '/v1/suspeita/update', susp, {headers});
}
    
export const suspeitaDelete = async(susp) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.delete(url + '/v1/suspeita/delete', {data: susp}, {headers});
}

